import { render } from "./banner-position.vue?vue&type=template&id=59017b0e&scoped=true&ts=true"
import script from "./banner-position.vue?vue&type=script&lang=ts"
export * from "./banner-position.vue?vue&type=script&lang=ts"

import "./banner-position.vue?vue&type=style&index=0&id=59017b0e&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59017b0e"]])

export default __exports__